import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import selectors from '../selectors';
import entryActions from '../entry-actions';
import { BoardMembershipRoles } from '../constants/Enums';
import Board from '../components/Board';

const mapStateToProps = state => {
  const { cardId } = selectors.selectPath(state);
  const currentUserMembership = selectors.selectCurrentUserMembershipForCurrentBoard(state);
  const allListIds = selectors.selectListIdsForCurrentBoard(state);
  const listNames = selectors.selectListNamesForCurrentBoard
    ? selectors.selectListNamesForCurrentBoard(state)
    : [];

  const isCurrentUserEditor =
    !!currentUserMembership && currentUserMembership.role === BoardMembershipRoles.EDITOR;

  const onlyOwnCards =
    !!currentUserMembership &&
    currentUserMembership.role === BoardMembershipRoles.VIEWER &&
    !!currentUserMembership.onlyOwnCards;

  const filteredListIds = onlyOwnCards
    ? selectors.selectFilteredListIdsForCurrentBoard(state)
    : allListIds;

  const filteredListNames =
    onlyOwnCards && filteredListIds && allListIds
      ? allListIds.reduce((acc, id, idx) => {
          if (filteredListIds.includes(id)) {
            acc.push(listNames[idx] || '');
          }
          return acc;
        }, [])
      : listNames;

  return {
    listIds: filteredListIds,
    listNames: filteredListNames,
    isCardModalOpened: !!cardId,
    canEdit: isCurrentUserEditor,
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      onListCreate: entryActions.createListInCurrentBoard,
      onListMove: entryActions.moveList,
      onCardMove: entryActions.moveCard,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Board);
